import * as React from "react";
import * as _ from "underscore";
import { Edit16 } from "@carbon/icons-react";

import Money from "../../../Money";

import { EMDASH, prependEllipsis, appendPercentageSign } from "./shared";

const ENTER_KEY = 13;

interface RevisableTextFieldProps {
  width: number;
  addEllipsis?: boolean;
  addDollarSign?: boolean;
  addPercentageSign?: boolean;
  original: string;
  revised: string;
  ignored: boolean;
  onUpdate: Function;
}

export default class RevisableTextField extends React.Component<RevisableTextFieldProps, any> {
  constructor(props: RevisableTextFieldProps) {
    super(props);
    this.state = { editing: false };
  }

  toggleEditing(bool: boolean) {
    this.setState({ editing: bool });
  }

  onChange(e) {
    this.props.onUpdate(e.target.value);
  }

  onKeyPress(e) {
    if (e.charCode === ENTER_KEY) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleEditing(false);
    }
  }

  renderRevisedField() {
    const {
      width,
      addEllipsis,
      addDollarSign,
      addPercentageSign,
      original,
      revised,
      ignored,
    } = this.props;

    if (this.state.editing) {
      return (
        <input
          type="text"
          autoFocus
          style={{ width }}
          value={revised || ""}
          onKeyPress={this.onKeyPress.bind(this)}
          onChange={this.onChange.bind(this)}
        />
      );
    }

    let revisedText;
    if (addEllipsis && revised !== null) {
      revisedText = prependEllipsis(revised);
    } else if (addDollarSign && revised !== null) {
      revisedText = <Money value={parseFloat(revised)} />;
    } else if (addPercentageSign && revised !== null) {
      revisedText = appendPercentageSign(revised);
    } else {
      revisedText = revised;
    }

    if (ignored) {
      return <div className="acct-attr-override__editor">{revisedText}</div>;
    }

    return (
      <div className="acct-attr-override__editor" onClick={this.toggleEditing.bind(this, true)}>
        <Edit16 />
        {revisedText}
      </div>
    );
  }

  render() {
    const { original, revised, addEllipsis, addDollarSign, addPercentageSign } = this.props;

    let textDecoration;
    if (revised) {
      textDecoration = "line-through";
    } else {
      textDecoration = "none";
    }

    let origText;
    if (original && addEllipsis) {
      origText = prependEllipsis(original);
    } else if (original && addDollarSign) {
      origText = <Money value={parseFloat(original)} />;
    } else if (original && addPercentageSign) {
      origText = appendPercentageSign(original);
    } else if (original) {
      origText = original;
    } else {
      origText = EMDASH;
    }

    return (
      <div className="acct-attr-override">
        <span style={{ textDecoration }}>{origText}</span>
        {this.renderRevisedField()}
      </div>
    );
  }
}
